const auth = '/auth';
// menu/topList
export default {
    "login": auth + "/login/accont",
    "current": auth + "/users/current",
    "allOrganizationJSON": auth + "/org/allOrganizationJSON",
    "allOrganization": auth + "/org/allOrganization",
    'addOrganiza': auth + "/org/addOrganiza",
    'entities': auth + "/org/entities",
    'findfindEntities': auth + "/org/findfindEntities",
    'updateOrganiza': auth + "/org/updateOrganiza",
    'delOrganiza': auth + "/org/delOrganiza",
    'usersIndex': auth + "/users/index",
    'menuAll': auth + "/menu/all",
    'addSamelevel': auth + "/menu/addSamelevel",
    'adeleteMenull': auth + "/menu/adeleteMenull",
    'updateMenu': auth + "/menu/updateMenu",
    'pageList': auth + "/users/pageList",
    'allMenu': auth + "/menu/all",
    'selfHasMenus': auth + "/menu/selfHasMenus",
    'addUser': auth + "/users/addUser",
    'deleUser': auth + "/users/deleUser",
    'sendYzm': auth + "/common/sendYzm",
    'changePassword': auth + "/common/changePassword",
    'updateUser': auth + "/users/updateUser",
    'selecDetailsByUserId': auth + "/users/selecDetailsByUserId",
    'uploadFile': auth + "/common/uploadFile",
    'logout': auth + "/logout",
    'serviceToken': auth + "/users/serviceToken",
    'clientIdIsUnique': auth + "/menu/clientIdIsUnique",
    'clients': auth + "/menu/clients",
}


// WEBPACK FOOTER //
// ./src/utils/api.js